import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eur',
  standalone: true,
  pure: true
})
export class EurPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value === null || value === undefined) return '';

    // Format the number as Euro currency in Dutch locale
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }
}